/*
 * Fairliar 自作・再入荷通知フォーム
 * - 売り切れバリアントが選択されている時だけ表示
 * - 送信は Google Apps Script Web App へ JSONP（CORSの影響を受けない）
 * - エンドポイント未設定のあいだは完全非表示。?restock_preview=1 で見た目のみ確認可
 */
(function () {
  if (window.customElements && customElements.get('restock-notify')) return;

  var ENDPOINT_RE = /^https:\/\/script\.google\.com\/macros\/s\/[A-Za-z0-9_-]+\/exec$/;
  var STORE_KEY = 'fairliar_restock_signups';

  function isPreview() {
    try {
      return new URLSearchParams(window.location.search).get('restock_preview') === '1';
    } catch (e) {
      return false;
    }
  }

  function readSignups() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function rememberSignup(variantId) {
    try {
      var s = readSignups();
      s[variantId] = 1;
      localStorage.setItem(STORE_KEY, JSON.stringify(s));
    } catch (e) {
      /* private mode 等は無視 */
    }
  }

  function jsonp(base, params, cb) {
    var name = 'restockCb_' + Math.random().toString(36).slice(2);
    var qs = ['callback=' + name];
    Object.keys(params).forEach(function (k) {
      if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
        qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
      }
    });

    var script = document.createElement('script');
    var done = false;

    function finish(res) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      try {
        delete window[name];
      } catch (e) {
        window[name] = undefined;
      }
      if (script.parentNode) script.parentNode.removeChild(script);
      cb(res);
    }

    var timer = setTimeout(function () {
      finish({ ok: false, error: 'timeout' });
    }, 15000);

    window[name] = function (res) {
      finish(res || { ok: false, error: 'empty' });
    };
    script.onerror = function () {
      finish({ ok: false, error: 'network' });
    };
    script.src = base + (base.indexOf('?') === -1 ? '?' : '&') + qs.join('&');
    document.head.appendChild(script);
  }

  class RestockNotifyElement extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.endpoint = this.dataset.endpoint || '';
      this.enabled = ENDPOINT_RE.test(this.endpoint);
      this.preview = isPreview();
      if (!this.enabled && !this.preview) return;

      try {
        this.variants = JSON.parse(this.dataset.variants || '[]');
      } catch (e) {
        this.variants = [];
      }

      this.trigger = this.querySelector('.restock-notify__trigger');
      this.panel = this.querySelector('.restock-notify__panel');
      this.input = this.querySelector('.restock-notify__input');
      this.submit = this.querySelector('.restock-notify__submit');
      this.msg = this.querySelector('.restock-notify__msg');
      this.target = this.querySelector('.restock-notify__target');
      if (!this.trigger || !this.panel || !this.input || !this.submit) return;

      if (this.dataset.email) this.input.value = this.dataset.email;

      this.trigger.addEventListener('click', this.togglePanel.bind(this));
      this.submit.addEventListener('click', this.send.bind(this));
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.send();
        }
      });

      this.watchVariant();
      this.update();
    }

    /* --- バリアント監視 ------------------------------------------------- */

    get idInput() {
      var form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
      return (form || document).querySelector('input[name="id"], .product-variant-id');
    }

    watchVariant() {
      var handler = this.update.bind(this);

      var input = this.idInput;
      if (input) {
        input.addEventListener('change', handler);
        // Dawn は value を直接書き換えるケースがあるので属性も監視
        new MutationObserver(handler).observe(input, {
          attributes: true,
          attributeFilter: ['value', 'disabled'],
        });
      }

      var btn = document.getElementById('ProductSubmitButton-' + (this.dataset.sectionId || ''));
      if (btn) {
        new MutationObserver(handler).observe(btn, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
      }

      document.addEventListener('change', (e) => {
        if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
          setTimeout(handler, 400);
        }
      });
    }

    currentVariant() {
      var input = this.idInput;
      var id = input && input.value ? String(input.value) : '';
      if (!id && this.variants.length === 1) id = this.variants[0].id;
      for (var i = 0; i < this.variants.length; i++) {
        if (String(this.variants[i].id) === id) return this.variants[i];
      }
      return null;
    }

    update() {
      var v = this.currentVariant();
      this.variant = v;

      var soldOut = !!v && v.available === false;
      if (this.preview && !soldOut) soldOut = true; // プレビュー時は常時表示

      if (!soldOut) {
        this.hidden = true;
        this.close();
        return;
      }

      this.hidden = false;
      if (this.target) {
        var label = v && v.title && v.title !== 'Default Title' ? v.title : this.dataset.product || '';
        this.target.textContent = label;
      }

      if (v && readSignups()[v.id]) {
        this.markDone('登録済みです。再入荷が決まりましたらご連絡いたします。');
      } else {
        this.classList.remove('restock-notify--done');
        this.trigger.disabled = false;
        this.trigger.querySelector('.restock-notify__trigger-label').textContent =
          '再入荷のお知らせを受け取る';
        if (this.msg) {
          this.msg.textContent = '';
          this.msg.className = 'restock-notify__msg';
        }
      }
    }

    /* --- UI ------------------------------------------------------------- */

    togglePanel() {
      if (this.classList.contains('restock-notify--done')) return;
      var open = this.panel.hidden;
      this.panel.hidden = !open;
      this.trigger.setAttribute('aria-expanded', String(open));
      if (open) this.input.focus();
    }

    close() {
      if (this.panel) this.panel.hidden = true;
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    }

    setMsg(text, kind) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.className = 'restock-notify__msg' + (kind ? ' restock-notify__msg--' + kind : '');
    }

    markDone(text) {
      this.classList.add('restock-notify--done');
      this.close();
      this.trigger.disabled = true;
      this.trigger.querySelector('.restock-notify__trigger-label').textContent = text;
    }

    /* --- 送信 ------------------------------------------------------------ */

    send() {
      var email = (this.input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        this.setMsg('メールアドレスをご確認ください。', 'error');
        this.input.focus();
        return;
      }
      var v = this.variant;
      if (!v) {
        this.setMsg('サイズを選択してください。', 'error');
        return;
      }
      if (!this.enabled) {
        this.setMsg('（プレビュー表示です。送信は行われません）', 'error');
        return;
      }

      this.submit.disabled = true;
      this.submit.textContent = '送信中…';
      this.setMsg('');

      var self = this;
      jsonp(
        this.endpoint,
        {
          email: email,
          variant_id: v.id,
          sku: v.sku || '',
          variant_title: v.title || '',
          product: this.dataset.product || '',
          handle: this.dataset.handle || '',
        },
        function (res) {
          self.submit.disabled = false;
          self.submit.textContent = '登録する';

          if (res && res.ok) {
            rememberSignup(v.id);
            self.markDone(
              res.duplicate
                ? '登録済みです。再入荷が決まりましたらご連絡いたします。'
                : '登録しました。再入荷が決まりましたらご連絡いたします。'
            );
            return;
          }
          if (res && res.error === 'invalid_email') {
            self.setMsg('メールアドレスをご確認ください。', 'error');
            return;
          }
          self.setMsg('送信できませんでした。時間をおいて再度お試しください。', 'error');
        }
      );
    }
  }

  customElements.define('restock-notify', RestockNotifyElement);
})();
